import { isLocal } from "../config/env";
import * as Sentry from "@sentry/browser";
import { hotjar } from "react-hotjar";

export const attachUserId = (address: string) => {
  if (!isLocal) {
    try {
      Sentry.setUser({ id: address });
      hotjar.identify("USER_ID", { userAddress: address });
    } catch (err) {
      console.error(err);
      Sentry.captureException(`Could not assign user address to hotjar`, {
        extra: { event: err },
      });
    }
  }
};
